export class RemoveDashboard {
  public static readonly type = '[Project/Dashboard/List] RemoveDashboard';
  constructor(public readonly id: string) {}
}
